import React from 'react'
import { CodeSurfer } from 'code-surfer';

import './code.css';
import { github } from '@code-surfer/themes';

const Code = ({ width, height, children }) => {
    var w = width || '100vw'
    var h = height || '100vh'

    return (    
        <div style={{width:`${w}`, height:`${h}`}}>
            <CodeSurfer theme={ github }>
                {children}
            </CodeSurfer>
        </div>
    )
}

export default Code